import { brandTokens } from '@/styles/theme/brand'
import { type ThemeConfig } from 'antd'

export const lightTheme: ThemeConfig = {
  hashed: false,
  cssVar: {
    prefix: '',
  },
  token: {
    colorPrimaryBg: '#FFF6F0',
    colorPrimaryBgHover: '#FFE8DB',
    colorPrimaryBorder: '#FFCBB3',
    colorPrimaryHover: '#FF8861',
    colorPrimary: '#F46036',
    colorPrimaryActive: '#CF4323',
    colorLink: '#F46036',
    colorInfoBg: '#EBF2FC',
    colorInfoBorder: '#90B9F1',
    colorInfoHover: '#6CA2ED',
    colorInfo: '#488BE8',
    colorSuccessBg: '#F4FFF2',
    colorSuccessBgHover: '#E6F8E9',
    colorSuccessBorder: '#B3E0BA',
    colorSuccess: '#79C886',
    colorSuccessHover: '#049B22',
    colorSuccessActive: '#016A1C',
    colorWarningBg: '#FFFBF2',
    colorWarningBgHover: '#FFEDD9',
    colorWarningBorder: '#FBE1C5',
    colorWarningBorderHover: '#F8CD9F',
    colorWarningHover: '#F6BA79',
    colorWarning: '#FAAD14',
    colorWarningActive: '#F3A653',
    colorErrorBg: '#FFF2F3',
    colorErrorBgHover: '#FFE4E7',
    colorErrorHover: '#F4737E',
    colorError: '#F14D5B',
    colorErrorActive: '#B1000F',
    fontFamily: 'Roboto, sans-serif',
    ...brandTokens,
  },
  components: {
    Layout: {
      headerBg: '#FFFFFF',
      bodyBg: '#FFFFFF',
    },
  },
}
